import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgYoutubeIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M15.203.097a17.286 17.286 0 0 0-2.844.4c-.5.11-1.322.36-2.03.622-.526.19-1.3.55-1.923.884-.79.425-1.84 1.135-2.5 1.681-1.784 1.488-3.14 3.191-4.162 5.225-.169.338-.307.622-.307.635 0 .01-.04.106-.09.212-.275.6-.672 1.816-.847 2.588-.103.462-.119.531-.156.75-.019.112-.047.265-.063.344-.015.078-.04.259-.06.406-.215 1.694-.196 3.14.066 4.75.079.481.291 1.456.37 1.687.012.044.055.185.093.313.834 2.834 2.56 5.49 4.844 7.46a15.67 15.67 0 0 0 4.562 2.765c.86.344 1.875.643 2.744.806.81.153 1.162.2 2.053.266.79.056 1.306.059 2.094 0 .931-.07 1.45-.141 2.375-.328.687-.141 1.972-.538 2.531-.785.035-.012.231-.097.438-.184 1.347-.572 2.803-1.49 4.047-2.56a22.21 22.21 0 0 0 1.746-1.768c1.907-2.285 3.147-5.032 3.57-7.891.096-.653.183-1.788.183-2.375 0-.356-.071-1.512-.106-1.781-.01-.06-.031-.228-.053-.375a15.835 15.835 0 0 0-.972-3.719c-.187-.472-.19-.481-.494-1.11a15.972 15.972 0 0 0-4.384-5.462 15.564 15.564 0 0 0-3-1.89 9.031 9.031 0 0 0-.684-.316c-.647-.294-1.853-.684-2.728-.878-.447-.1-.385-.088-.875-.169-.138-.025-.37-.06-.516-.078-.147-.022-.316-.044-.375-.053a28.788 28.788 0 0 0-1.844-.1c-.162 0-.478.012-.703.028Zm3.563 8.453c.862.016 2.875.094 3.156.122.087.006.284.022.437.031 1.153.072 2.007.228 2.438.447a2.744 2.744 0 0 1 1.356 1.616c.606 1.959.606 8.478 0 10.437a2.744 2.744 0 0 1-1.356 1.616c-.434.222-1.303.378-2.438.447-.172.009-.368.025-.437.03-.153.02-2.122.1-3.078.129-.9.025-4.81.025-5.688 0-3.878-.116-5.262-.256-5.953-.606a2.744 2.744 0 0 1-1.356-1.616c-.606-1.96-.606-8.478 0-10.437A2.743 2.743 0 0 1 7.203 9.15c.431-.219 1.278-.372 2.438-.447.156-.01.359-.025.453-.034.5-.044 2.453-.11 3.797-.128.843-.01 1.537-.025 1.546-.032.016-.015 1.557.004 3.329.041Z"
      fill="currentColor"
    />
    <path
      d="M13.844 15.984v3.138l.369-.213c.38-.221 2.253-1.28 4.037-2.293.575-.325 1.06-.604 1.072-.616.012-.012-.26-.184-.61-.381-.35-.2-1.259-.719-2.024-1.153-.766-.435-1.72-.975-2.116-1.204l-.728-.412v3.134Z"
      fill="currentColor"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgYoutubeStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgYoutubeIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const YoutubeIcon: any = SvgYoutubeStyle;
export default YoutubeIcon;
